/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChatMycheckSeriesDto } from './chatMycheckSeriesDto';

export interface ChatThreadDto { 
    id?: string;
    projectId?: number;
    topic?: string;
    mode?: ChatThreadDto.ModeEnum;
    rulesetId?: string;
    mycheckType?: ChatThreadDto.MycheckTypeEnum;
    messageCount?: number;
    createdAt?: Date;
    lastMessageAt?: Date;
    mycheckSeries?: ChatMycheckSeriesDto;
}
export namespace ChatThreadDto {
    export type ModeEnum = 'CLASSIC' | 'MYCHECK' | 'EDIT';
    export const ModeEnum = {
        CLASSIC: 'CLASSIC' as ModeEnum,
        MYCHECK: 'MYCHECK' as ModeEnum,
        EDIT: 'EDIT' as ModeEnum
    };
    export type MycheckTypeEnum = 'KI' | 'IDS' | 'HYBRID' | 'CROSS';
    export const MycheckTypeEnum = {
        KI: 'KI' as MycheckTypeEnum,
        IDS: 'IDS' as MycheckTypeEnum,
        HYBRID: 'HYBRID' as MycheckTypeEnum,
        CROSS: 'CROSS' as MycheckTypeEnum
    };
}